import React, { useState, useEffect,useRef } from "react";
import { MultiSelect } from "primereact/multiselect";
import { Controller } from "react-hook-form";
import popup_close from '../../assests/images/popup_close.png';
import '../../style/multiSelect.scss';


const CommonMultiSelect = ({
  name,
  label,
  options,
  validationFn,
  register,
  control,
  errors,
  placeholder = "Seleziona le opzioni",
  disabled = false,
  formatOptions,
  maxSelectedLabels = 3,
  selectedValuesChip,
  setSelectedValuesChip
}) => {
  const [loading, setLoading] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedAll,setSelectedAll] =useState([])
  const selectRef = useRef();
  useEffect(() => {
    if (options && options.length > 0) {
      setLoading(false);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, []);
  // Id alone
  // const handleSelection = (e,field) => {
  //   setSelectedValues((prev) => {
  //     const newValues = Array.isArray(e.value) ? e.value : [];
  //     return [...newValues, ...prev]; 
  //   });
  //   field.onChange(e.value || []);
  //   selectRef.current.hide();
  // };

  // const handleSelection = (e, field) => {
  //   setSelectedValues((prev) => {
  //     const selectedObjects = options.filter((opt) => e.value.includes(opt.code)); 
  //     return [...selectedObjects,...prev]; 
  //   });
  
  //   field.onChange(e.value || []);
  //   selectRef.current.hide();
  // };

;

  const handleSelection = (e, field) => {
    setSelectedValuesChip((prev) => {
      // Get newly selected objects from options based on e.value
      const selectedObjects = options.filter((opt) => e.value.includes(opt.code));
  
      // Retain previous selections that are already in the field value
      const previousSelections = prev || []
  
      // Merge previous and new selections, ensuring uniqueness
      const updatedSelections = [...selectedObjects,...previousSelections].filter(
        (obj, index, self) => self.findIndex(o => o.code === obj.code) === index
      );
  
      return updatedSelections;
    });
    field.onChange(e.value || []);
    selectRef.current.hide();
  };
  // useEffect(() => {
  //   setSelectedAll((prev) => {
  //     let newSelected = selectedValues
  //       .map((selectedCode) => options?.find((opt) => opt?.code === selectedCode))
  //       .filter(Boolean); // Remove undefined values
  
  //     let updatedSelection = [...newSelected, ...prev].filter(
  //       (value, index, self) => value && self.findIndex((v) => v.code === value.code) === index
  //     );

  //     return updatedSelection;
  //   });
  // }, [selectedValues, options]); 
 
  return (
    <div className="p-field common-p-dropdown dropdown-container custom-dropdown-container dropdown-checkbox">
      {label && (
        <label htmlFor={name} className="mt-2 fw-bold">
          {label}
        </label>
      )}
      {/* {loading ? (
        <p>Loading...</p>
      ) : options && options.length > 0 ? ( */}
        <Controller
          name={name}
          control={control}
          rules={{
            validate: (value) => {
              const { errorFlag, error } = validationFn({
                FieldName: name,
                value,
              });
              if (errorFlag) {
                return error;
              }
              return true;
            },
          }}
          render={({ field }) => (
            <div>
            <MultiSelect
              id={name}
              {...field}
              options={options?.filter((each) => each?.selected)?.map(({selected, ...rest}) => rest)}
              optionLabel="name" 
              optionValue="code"
              placeholder={"Please Select"}
              disabled={disabled}
              className="custom-multiselect w-full"
              appendTo="self"
              panelClassName="custom-options"
              showSelectAll={false}
              showClear={false} 
              onChange={(e)=>handleSelection(e,field)}
              style={{
                marginBottom: 20,
                borderRadius: "50px", 
                backgroundColor:'#eff9fd',
                width: '100%'
              }}
              value={[]} 
              maxSelectedLabels={options.length} 
              selectedItemsLabel="" 
              valueTemplate={() => <span className="text-gray-400">{placeholder}</span>} 
              ref={selectRef}

            />
            <div className="multi-select-option-container mt-5">             
            {selectedValuesChip && selectedValuesChip?.length > 0 &&  (
                 selectedValuesChip?.map((selectedCode) => {
                    const selectedItem = options?.find((opt) => opt?.code === selectedCode);
                    console.log("selectedItem",selectedCode)
                    return (
                      <div
                        key={selectedCode}
                        className="dropdoemContainer"
                      >
                        <div className="dropdownText">{selectedCode?.name}</div>
                        <img
                          src={popup_close}
                          alt="Close"
                          className="cursor-pointer  ml-2"
                          onClick={() => {
                            setSelectedValuesChip((prev) => prev?.filter((item) => item?.code !== selectedCode?.code));
                            field?.onChange(field?.value?.filter((val) => val !== selectedCode?.code));
                          }}
                        />
                      </div>
                    );
                  })
                )
                }
            </div>
            </div>
          )}
        /> 
      {/* // ) : (
      //   <p>Nessun dato trovato</p>
      // ) */}
      {/* } */}

      {errors?.[name] && (
        <small className="p-error">{errors[name]?.message}</small>
      )}
    </div>
  );
};

export default CommonMultiSelect;
  // onClick={() => {
                          //   const newValues = .filter((code) => code.code !== selectedCode.code);
                          //   setSelectedAll(newValues); // Update the state
                          //   setSelectedValues(newValues.map((item) => item.code)); // Also update selected values
                          //   field.onChange(newValues.map((item) => item.code)); // Update the form field
                          // }}